import { h } from '@stencil/core';
export const Container = (props, children, utils) => {
  if (!children.length) {
    return null;
  }
  return (h("div", { class: {
      'cta-area': true,
      'cta-area-pbs': props.isPBS,
      'cta-area--prioritized-buy-now-button': props.prioritizeBuyNowButton,
      'cta-area--has-slotted-discounted-price': props.hasSlottedDiscountedPrice,
    } }, h("div", { class: "cta-area__container" }, utils.map(children, (child) => {
    var _a;
    return Object.assign(Object.assign({}, child), { vattrs: Object.assign(Object.assign({}, child.vattrs), { class: `${(_a = child.vattrs.class) !== null && _a !== void 0 ? _a : ''} ${child.vattrs.class === 'cta-shoppable' ? '' : 'cta-area__container-block'}` }) });
  }))));
};
